// extracted by mini-css-extract-plugin
module.exports = {"productAccordionListWrapper":"ProductAccordionList_productAccordionListWrapper__2bd0D"};